<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-30 no-padding">
        <cmp-preview-list-comp @returnCmpPreview="onClickCmpPreviewList" ref="cmpPreviewListSearch"></cmp-preview-list-comp>
      </div>
      <div class="md-layout-item md-size-70 no-padding">
        <md-card>
          <md-card-header>
            <h4 class="title">
              <md-icon>description</md-icon>캠페인 정보
            </h4>
          </md-card-header>
          <div class="md-group tab-area">
            <md-button class="md-default md-white" @click="onClickTab(1)" v-bind:class="showTab==1 ? 'active':''">캠페인 결과</md-button>
            <md-button class="md-default md-white" @click="onClickTab(2)" v-bind:class="showTab==2 ? 'active':''">상담원 통화 여부</md-button>
          </div>
          <div class="simple-tab-group">
            <div v-show="showTab === 1">
              <md-card-content class="md-layout">
                <div class="md-layout-item md-size-35 no-padding">
                  <md-table :value="counselorCallList2" class="paginated-table table-striped table-hover text-align-center">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="상담원">{{ item.userNm }}</md-table-cell>
                      <md-table-cell md-label="Call 구분">{{ item.resultNm }}</md-table-cell>
                      <md-table-cell md-label="건수"><a style="cursor: pointer" @click="clickCount(item)">{{ item['count(*)'] }}</a></md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
                <div class="md-layout-item md-size-45 no-padding">
                  <md-table :value="counselorCallList" class="paginated-table table-striped table-hover text-align-center">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="상담원">{{ item.userNm }}</md-table-cell>
                      <md-table-cell md-label="Call 구분">{{ item.resultNm }}</md-table-cell>
                      <md-table-cell md-label="Call 사용구분">{{ item.callResultNm }}</md-table-cell>
                      <md-table-cell md-label="건수"><a style="cursor: pointer" @click="clickCount(item)">{{ item['count(*)'] }}</a></md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>

                <div class="md-layout-item md-size-20 no-padding">
                  <md-table :value="campaignCallCountList" class="paginated-table table-striped table-hover text-align-center">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="처리일">{{ item.endDate }}</md-table-cell>
                      <md-table-cell md-label="처리건수">{{ item['count(*)'] }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </md-card-content>

              <md-card-content class="md-layout">
                <div class="md-layout-item md-size-35 no-padding">
                  <md-table :value="campaignDistribution" class="paginated-table table-striped table-hover text-align-center">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="상담원">{{ item.userNm }}</md-table-cell>
                      <md-table-cell md-label="분배건수">{{ item['count(*)'] }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </md-card-content>
            </div>

            <div v-show="showTab === 2">
              <md-card-content>
                <div style="position: absolute; top: -35px; right: 10px;">
                  <input type="text" v-model="cmpResultListQuery.cCustNm" class="w120" style="margin-right: 10px;">
                  <md-button class="md-info md-sm" @click="getCmpResultList('')">
                    <md-icon>search</md-icon>
                    교우명 검색
                  </md-button>
                </div>

                <cmp-result-list-comp :list-type="'call'" ref="cmpResultListSearch"></cmp-result-list-comp>
<!--                <md-table-->
<!--                  :value="cmpResultList"-->
<!--                  class="paginated-table table-striped table-hover text-align-center"-->
<!--                >-->
<!--                  <md-table-row-->
<!--                    slot="md-table-row"-->
<!--                    slot-scope="{ item }"-->
<!--                  >-->
<!--                    <md-table-cell md-label="교우번호">{{ item.cCustId }}</md-table-cell>-->
<!--                    <md-table-cell md-label="교우명">{{ item.cCustNm }}</md-table-cell>-->
<!--                    <md-table-cell md-label="배정상담원">{{ item.cAgentId }}</md-table-cell>-->
<!--                    <md-table-cell md-label="통화여부">{{ item.resultNm }}</md-table-cell>-->
<!--                    <md-table-cell md-label="결과">{{ item.callResultNm }}</md-table-cell>-->
<!--                    <md-table-cell md-label="비고">{{ item.remark }}</md-table-cell>-->
<!--                  </md-table-row>-->
<!--                </md-table>-->
              </md-card-content>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import parser from "@/kuaa/kuaa-parser";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";
import moment from "moment";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import axios from "axios";

import cmpPreviewListComp from "@/pages/Counselor/Components/cmpPreviewListComp"
import cmpResultListComp from "@/pages/Counselor/Components/cmpResultListComp"

export default {
  components: {
    cmpPreviewListComp,
    cmpResultListComp
  },
  mounted (){
  },
  beforeDestroy(){
    // kuaaFnc.destroyTab();
  },
  data(){
    return {
      showTab: 2,
      isAdmin: (session.get("group") === "3" || session.get("group") === "5")? true: false,
      cmpResultListQuery : {
        cCmpId: '',
        cCustNm: ''
      },

      cmpResultList: [],
      counselorCallList: [],
      counselorCallList2: [],
      campaignCallCountList: [],
      campaignDistribution: []

    }
  },

  methods: {
    onClickTab(index){
      this.showTab = index
    },
    
    onClickCmpPreviewList(item) {
      this.getCmpResultList(item.CCmpId, true);
      this.getCmpCallList(item.CCmpId);
      this.getCmpDistributionList(item.CCmpId);
      this.showTab = 1;
    },

    getCmpCallList (cCmpId) {
      let options = {
        agentId : this.isAdmin ? null : session.get('userNo'),
        cCmpId : cCmpId
      };
      kuaaApi.sendServer(
        URL_CONST.GET_CMP_CALL_RESULT_COUNT_LOG,
        options,
        "post",
        response => {
          if (response.data.result){
            this.counselorCallList = response.data.data.contents;
          } else {
            this.counselorCallList = [];
          }
          this.campaignCallCountList = [];
        }
      );

      kuaaApi.sendServer(
        URL_CONST.GET_CMP_CALL_RESULT_COUNT_TOTAL_LOG,
        options,
        "post",
        response => {
          if (response.data.result){
            this.counselorCallList2 = response.data.data.contents;
          } else {
            this.counselorCallList2 = [];
          }
        }
      );
    },
    getCmpDistributionList(cCmpId){
      let options = {
        agentId : this.isAdmin ? null : session.get('userNo'),
        cCmpId : cCmpId
      };
      kuaaApi.sendServer(
          URL_CONST.GET_CMP_DISTRIBUTION_LIST,
          options,
          "post",
          response => {
            if (response.data.result){
              this.campaignDistribution = response.data.data.contents;
            } else {
              this.campaignDistribution = [];
            }
          }
      );
    },
    clickCount(item){
      let options = {
        agentId : item.userNo, // this.isAdmin ? null : session.get('userNo'),
        cCmpId : this.cmpResultListQuery.cCmpId,
        callCd : item.result,
        callUseCd : item.callResult,
      };
      kuaaApi.sendServer(
        URL_CONST.GET_CMP_DATE_RESULT_COUNT_LOG,
        options,
        "post",
        response => {
          if (response.data.result){
            this.campaignCallCountList = response.data.data.contents;
          } else {
            this.campaignCallCountList = [];
          }
        }
      );
    },

    getCmpResultList(cCmpId, reset) {
      if (cCmpId) {
        this.cmpResultListQuery.cCmpId = cCmpId;
      }

      let options = {
        cCmpId : this.cmpResultListQuery.cCmpId,
        perPage: 10000
      };
      if(reset){
        this.cmpResultListQuery.cCustNm = '';
      }else if (!reset && this.cmpResultListQuery.cCustNm) {
        options.cCustNm = this.cmpResultListQuery.cCustNm;
      }

      this.$refs.cmpResultListSearch.sendQuery(options.cCmpId, options.cCustNm);

      // kuaaApi.sendServer(URL_CONST.GET_CMP_RESULT_LIST, options, "post", response => {
      //   this.showTab = 2;
      //   if (reset) {
      //     this.cmpResultListQuery.cCustNm = '';
      //   }
      //
      //   // 캠페인 결과
      //   this.cmpResultList = response.data.data.contents;
      //   this.pagination.total = response.data.data.pagination.totalCount;
      //
      //   // 상담원 통화 여부 왼쪽 테이블 시작
      //   let tempArr = [];
      //   let temp = {};
      //   this.cmpResultList.forEach((item)=>{
      //     if (typeof temp[item.cAgentId] === 'undefined') {
      //       temp[item.cAgentId] = {};
      //     }
      //     if (typeof temp[item.cAgentId][item.resultNm] === 'undefined') {
      //       temp[item.cAgentId][item.resultNm] = 0;
      //     }
      //
      //     temp[item.cAgentId][item.resultNm]++;
      //   });
      //
      //   let len = 0;
      //   Object.keys(temp).forEach((item)=>{
      //     Object.keys(temp[item]).forEach((item2)=>{
      //       len++;
      //
      //       tempArr.push({
      //         id: len,
      //         cAgentId: item,
      //         resultNm: item2,
      //         count: temp[item][item2]
      //       });
      //     });
      //   });
      //
      //   this.counselorCallList = tempArr;
      //   // 상담원 통화 여부 왼쪽 테이블 끝
      //
      //   // 상담원 통화 여부 오른쪽 테이블 시작
      //   let tempArr2 = [];
      //   let temp2 = {};
      //   this.cmpResultList.forEach((item)=>{
      //     if (!item.startDate) {
      //       return;
      //     }
      //
      //     if (typeof temp2[item.startDate] === 'undefined') {
      //       temp2[item.startDate] = 0;
      //     }
      //
      //     temp2[item.startDate]++;
      //   });
      //
      //   let len2 = 0;
      //   Object.keys(temp2).forEach((item)=>{
      //     len2++;
      //
      //     tempArr2.push({
      //       id: len2,
      //       startDate: item,
      //       count: temp2[item]
      //     });
      //   });
      //
      //   this.campaignCallCountList = tempArr2;
      //   // 상담원 통화 여부 오른쪽 테이블 끝
      // });
    },

    
  }
}
</script>

<style>

</style>